import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import moment from 'moment';

import Node from '../../common/Node';
import LoaderNew from '../../common/LoaderNew';
import CommonStyles from '../../common/CommonStyles';
import ArrowTooltip from '../../common/ArrowTooltip';
import TrplForm from '../../common/TrplForm/TrplForm';
import FullScreenDialog from '../../common/FullScreenDialog';
import ComponentWrapper from '../../common/ComponentWrapper';

import AncestorsPage from '../Ancestors/AncestorsPage';

import Add from '@mui/icons-material/Add';
import Edit from '@mui/icons-material/Edit';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import Check from '@mui/icons-material/Check';
import { SwapHoriz } from '@mui/icons-material';

import { NODE_TITLE } from '../../constants';

import InterfaceDialog from './components/InterfaceDialog';

import { getNodeAvatar } from '../../utils';

const styles = {
  paper: {
    background: '#fff',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.03)',
    position: 'relative',
    '&:hover': {
      '& .node-page-edit-btn': {
        display: 'flex',
      },
    },
  },
  nodeHeader: {
    display: 'flex',
    padding: '10px 0',
    marginBottom: '20px',
    alignItems: 'center',
    '&:hover': {
      '& .node-page-edit-btn': {
        display: 'flex',
      },
    },
  },
  nodeAvatar: {
    width: '60px',
    height: '60px',
    borderRadius: '100%',
    marginRight: '20px',
  },
  nodeHeaderContent: {
    flexDirection: 'column',
    position: 'relative',
  },
  nodeTitle: {
    fontSize: '24px',
    marginBottom: '2px',
    color: '#4E4C4C',
  },
  nodeDescription: {
    display: 'flex',
    fontSize: '12px',
    color: '#7D7D7D',
  },
  nodeTitleEditIcon: {
    position: 'absolute',
    right: '8px',
    bottom: '8px',
    color: '#C4C4C4',
  },
  nodeHeaderEditBtn: {
    top: '5px',
    right: '-34px',
    display: 'none',
    color: '#C4C4C4',
    position: 'absolute',
    '&:hover': {
      color: '#7D7D7D',
    },
  },
  individ: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
  },
  individCheckIcon: {
    color: '#7D7D7D;',
    fontSize: '24px',
    marginRight: '10px',
  },
  swichToInterfaceIcon: {
    color: '#7D7D7D;',
    fontSize: '20px',
    cursor: 'pointer',
    marginRight: '10px',
    '&:hover': {
      color: '#347CFF',
    },
  },
  individTitle: {
    fontSize: '16px',
    color: '#7D7D7D',
    marginRight: '41px',
  },
  individContent: {
    fontSize: '12px',
    color: '#7D7D7D',
    display: 'flex',
    padding: '7px 10px 7px 20px',
  },
  concept: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
  },
  conceptTitle: {
    color: '#7D7D7D',
    fontSize: '16px',
    marginRight: '14px',
  },
  conceptDescription: {
    fontSize: '12px',
    color: '#C4C4C4',
  },
  incomingTrpls: {
    color: '#4E4C4C',
    fontSize: '12px',
    fontWeight: 'bold',
    marginRight: '10px',
  },
  groupTitle: {
    display: 'flex',
    fontSize: '16px',
    color: '#7D7D7D',
    background: '#FBFBFB',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '7px 0',
  },
  conceptsNodes: {
    padding: '20px',
  },
  groupAddBtnIcon: {
    position: 'absolute',
    display: 'none',
    right: '20px',
    top: '46px',
    color: '#C4C4C4',
    '&:hover': {
      color: '#7D7D7D',
    },
  },
  individsContent: {
    display: 'flex',
    height: '60px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  individsContentBig: {
    fontSize: '30px',
    color: '#4E4C4C',
    display: 'flex',
    marginRight: '5px',
  },
  individsContentSmall: {
    fontSize: '14px',
    color: '#7D7D7D',
    position: 'relative',
    top: '6px',
  },
  restrictionsContent: {
    height: '60px',
    color: '#4E4C4C',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '30px',
  },
  widgetLink: {
    color: '#4E4C4C',
    textDecoration: 'underline',
    fontSize: '12px',
  },
  h60: {
    height: '60px',
  },
  row: {
    lineHeight: '27px',
    border: '1px solid #FBFBFB',
  },
  viewsTable: {
    width: '100%',
    color: '#4E4C4C',
    fontSize: '12px',
  },
  ...CommonStyles,
};

class NodePage extends ComponentWrapper {
  state = {
    loaded: false,
    nodes: {},
    node: {
      id: 0,
      title: 'No title',
    },
    newImplModal: {
      isOpened: false,
      type: 'isa',
    },
    data: {
      ioi: [],
      isa: [],
      widget: 0,
      views: [],
      nodeId: null,
      ako_subs: [],
      ako_supers: [],
      descr_individ: '',
      descr_concept: '',
      is_interface: false,
      inds_explicit_number: 0,
      inds_implicit_number: 0,
      restrictions_number: 0,
    },
    interfaceDialogOpen: false,
  };

  componentDidMount() {
    const { nodeId } = this.props.match.params;

    this.get({
      url: `/get_node?id=${nodeId}`,
      cb: (res) => {
        if (res.data) {
          const data = {
            ioi: res.data.node.box.i,
            isa: res.data.isa,
            n_preds: res.data.n_preds,
            widget: res.data.widget,
            ako_subs: res.data.ako_subs,
            tag: res.data.node.tag || '',
            ako_supers: res.data.ako_supers,
            creator: res.data.node.creator || '',
            creator_iid: res.data.node.creator_iid || '',
            descr_individ: res.descr_individ || '',
            descr_concept: res.descr_concept || '',
            is_interface: res.data.node.is_interface,
            restrictions_number: res.data.restrictions_number,
            inds_explicit_number: res.data.inds_explicit_number,
            inds_implicit_number: res.data.inds_implicit_number,
            trpls_incoming_number: res.data.trpls_incoming_number,
            restrictions_incoming_number: res.data.restrictions_incoming_number,
            nodeId,
          };

          const views = [];

          const { jels } = this.props;

          jels.tables.forEach((tblId) => {
            const tbl = jels.jelData[tblId];

            if (+nodeId === +tbl.concept)
              views.push({
                id: tbl.id,
                title: tbl.title,
                type: 'trpls_tbl',
              });
          });

          jels.forms.forEach((frmId) => {
            const frm = jels.jelData[frmId];

            if (+nodeId === +frm.concept)
              views.push({
                id: frm.id,
                title: frm.title,
                type: 'trpls_frm',
              });
          });

          data.views = views;

          this.setState({
            data,
            loaded: true,
            node: res.data.node,
            nodes: res.data.nodes,
          });

          document.title=`${res.data.node.title} | Milkyweb`;
        }
      },
    });
  }

  toggleNewImplModal = (newImplModal) => {
    if (!newImplModal.isOpened) {
      const { node } = this.state;

      this.get({
        url: `/get_node?id=${node.id}`,
        cb: (res) => {
          const { data } = this.state;

          data.ioi = res.data.node.box.i;
          data.isa = res.data.isa;
          data.widget = res.data.widget;
          data.ako_subs = res.data.ako_subs;
          data.ako_supers = res.data.ako_supers;
          data.inds_explicit_number = res.data.inds_explicit_number;
          data.inds_implicit_number = res.data.inds_implicit_number;
          data.restrictions_number = res.data.restrictions_number;

          this.setState({
            data,
            newImplModal,
            node: res.data.node,
            nodes: res.data.nodes,
          });
        },
      });
    } else {
      this.setState({ newImplModal });
    }
  };

  setConceptToInterfaceMode = () => {
    const { node, data } = this.state;

    const reqData = {
      id: node.id,
      is_interface: !data.is_interface
    };

    this.postWithData({
      url: `/set_is_interface`,
      data: reqData,
      cb: (req) => {

        data.is_interface = req.node.is_interface;
        this.setState({ data, interfaceDialogOpen: false });
      },
    });
  };

  render() {
    const { classes } = this.props;
    const { loaded, nodes, node, data, newImplModal, interfaceDialogOpen } = this.state;

    const showTrplForm = (data.n_preds && Object.keys(data.n_preds).length) || node.is_individ;

    return (
      <div className={classes.container} style={{ marginBottom: '50px' }}>
        {!loaded ? (
          <div className={classes.justifyCenter}>
            <LoaderNew />
          </div>
        ) : (
          <div>
            <InterfaceDialog
              classes={classes}
              is_interface={data.is_interface}
              interfaceDialogOpen={interfaceDialogOpen}
              setConceptToInterfaceMode={this.setConceptToInterfaceMode}
              onClose={() => this.setState({ interfaceDialogOpen: false })}
            />

            <FullScreenDialog
              title="Add tag"
              isOpen={newImplModal.isOpened}
              onClose={() => {
                this.toggleNewImplModal({
                  isOpened: false,
                  type: 'isa',
                });
              }}
            >
              <AncestorsPage isEmbed iid={node.id} type={newImplModal.type} />
            </FullScreenDialog>

            <div className={`${classes.nodeHeader}`}>
              {node.pic ? <img src={getNodeAvatar(node, '70')} alt="node-avatar" className={classes.nodeAvatar} /> : null}

              <div className={classes.nodeHeaderContent}>
                  <div className={`${classes.alignCenter}`}>
                    <div className={`${NODE_TITLE} ${classes.nodeTitle} ${classes.mr10}`}>{node ? node.title : 'No title'}</div>
                    {data.tag ? <span style={{ color: '#878787' }}>#{data.tag}</span> : null}
                  </div>

                <div className={classes.nodeDescription}>
                  <span className={classes.mr10}>Ontology: {node.ontology}</span>

                  <span className={classes.mr10}>
                    Date added: {moment(node.creation_time).format('DD MMM YYYY HH:mm')}
                  </span>

                  {data.creator ? <span className={classes.mr10}>Creator: {data.creator} / {data.creator_iid}</span> : null}
                </div>

                <a className={`node-page-edit-btn ${classes.nodeHeaderEditBtn}`} href={`/edit?id=${node.id}`}>
                  <Edit className={`${classes.pointer}`} />
                </a>
              </div>
            </div>

            <div className={classes.flex}>
              <div className={`${classes.col50} ${classes.pr20}`}>
                <div className={`${classes.individ} ${!node.is_individ ? classes.op5 : ''} ${classes.hoverOp1}`}>
                  {node.is_individ ? (
                    <Check className={classes.individCheckIcon} />
                  ) : (
                    <CircleOutlinedIcon className={classes.individCheckIcon} />
                  )}

                  {data.descr_individ ? (
                    <ArrowTooltip title={data.descr_individ}>
                      <span className={classes.individTitle}>Individual</span>
                    </ArrowTooltip>
                  ) : (
                    <span className={classes.individTitle}>Individual</span>
                  )}
                </div>

                <div className={classes.flex}>
                  <div className={`${classes.col50} ${classes.pr10}`}>
                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_individ ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Concepts</div>

                      {data.isa.length ? (
                        <div style={{ padding: '20px 20px 10px 20px' }}>
                          {data.isa.map((concept, conceptIndex) => {
                            return (
                              <Node
                                isLink
                                size="md"
                                nodeId={concept}
                                key={conceptIndex}
                                node={nodes[concept]}
                                nodes={nodes}
                                className={`${classes.mr10} ${classes.mb10}`}
                              />
                            );
                          })}
                        </div>
                      ) : (
                        <div className={classes.h60} />
                      )}

                      <Edit
                        className={`node-page-edit-btn ${classes.groupAddBtnIcon} ${classes.pointer}`}
                        onClick={() =>
                          this.toggleNewImplModal({
                            isOpened: true,
                            type: 'isa',
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className={`${classes.col50}`}>
                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_individ ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Additional information</div>

                      <div className={classes.p20}>
                        <span className={classes.incomingTrpls}>Incoming triples:</span>

                        {data.trpls_incoming_number > 0 ? (
                          <a href={`/trpls?oid=${node.id}`} className={classes.widgetLink}>
                            <span>{data.trpls_incoming_number}</span>
                          </a>
                        ) : (
                          <span>{data.trpls_incoming_number}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${classes.group} ${classes.paper} ${classes.mb40} ${showTrplForm ? '' : classes.op5} ${
                    classes.hoverOp1
                  }`}
                >
                  <div className={classes.groupTitle}>Triples</div>

                  {showTrplForm ? (
                    <div style={{ padding: '0 0 10px 20px' }}>
                      <TrplForm
                        embed
                        mode="edit" 
                        groups={[]} 
                        disableTitle
                        isSearchByRst
                        disableLeftCol 
                        iId={!node.is_concept && node.id}
                        formConceptId={node.is_concept && node.id}
                        />
                    </div>
                  ) : (
                    <div className={classes.h60} />
                  )}
                </div>
              </div>

              <div className={classes.col50}>
                <div className={`${classes.concept} ${!node.is_concept ? classes.op5 : ''} ${classes.hoverOp1}`}>
                  {node.is_concept ? (
                    <Check className={classes.individCheckIcon} />
                  ) : (
                    <CircleOutlinedIcon className={classes.individCheckIcon} />
                  )}

                  {data.descr_concept ? (
                    <ArrowTooltip title={data.descr_concept}>
                      <span className={classes.conceptTitle}>Concept</span>
                    </ArrowTooltip>
                  ) : (
                    
                    <div style={{ display: 'flex', alignItems: 'center'}}>
                      {data.is_interface ?
                        <span className={classes.conceptTitle}>Interface</span>
                        : <span className={classes.conceptTitle}>Concept</span>}
                      <SwapHoriz
                        className={classes.swichToInterfaceIcon}
                        onClick={() => {
                          this.setState({ interfaceDialogOpen: true });
                        }}
                      />
                    </div>
                  )}
                </div>

                <div className={classes.flex}>
                  <div className={`${classes.col50} ${classes.pr10}`}>
                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_concept ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Individuals</div>

                      <a href={`/tbl?id=${node.id}`} className={classes.individsContent}>
                        <span title="all" className={classes.individsContentBig}>
                          {node.is_concept && `${data.inds_implicit_number || '0'}`}
                        </span>
                        <span title="explicit" className={classes.individsContentSmall}>
                          {data.inds_implicit_number ? `/ ${data.inds_explicit_number}` : ''}
                        </span>
                      </a>

                      <a href={`/create_node?cid=${node.id}`}>
                        <Add className={`node-page-edit-btn ${classes.groupAddBtnIcon} ${classes.pointer}`} />
                      </a>
                    </div>

                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_concept ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Supers</div>

                      {data.ako_supers.length ? (
                        <div className={`${classes.conceptsNodes} ${classes.column}`}>
                          {data.ako_supers.map((concept, conceptIndex) => {
                            return (
                              <Node
                                isLink
                                size="md"
                                nodeId={concept}
                                key={conceptIndex}
                                node={nodes[concept]}
                                nodes={nodes}
                                className={`${conceptIndex !== data.ako_supers.length - 1 ? classes.mb10 : ''}`}
                              />
                            );
                          })}
                        </div>
                      ) : (
                        <div className={classes.h60} />
                      )}

                      <Edit
                        className={`node-page-edit-btn ${classes.groupAddBtnIcon} ${classes.pointer}`}
                        onClick={() =>
                          this.toggleNewImplModal({
                            isOpened: true,
                            type: 'ako',
                          })
                        }
                      />
                    </div>

                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_concept ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Implementation of interface</div>

                      {data.ioi && data.ioi.length ? (
                        <div className={`${classes.conceptsNodes} ${classes.column}`}>
                          {data.ioi.map((concept, conceptIndex) => {
                            return (
                              <Node
                                isLink
                                size="md"
                                nodeId={concept}
                                key={conceptIndex}
                                node={nodes[concept]}
                                nodes={nodes}
                                className={`${conceptIndex !== data.ioi.length - 1 ? classes.mb10 : ''}`}
                              />
                            );
                          })}
                        </div>
                      ) : (
                        <div className={classes.h60} />
                      )}

                      <Edit
                        className={`node-page-edit-btn ${classes.groupAddBtnIcon} ${classes.pointer}`}
                        onClick={() =>
                          this.toggleNewImplModal({
                            isOpened: true,
                            type: 'ioi',
                          })
                        }
                      />
                    </div>

                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_concept ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Additional information</div>

                      <div className={classes.p20}>
                        <div className={classes.mb20}>
                          <span className={classes.incomingTrpls}>Incoming restrictions:</span>
                          <span>{data.restrictions_incoming_number}</span>
                        </div>

                        <div className={classes.mb20}>
                          <span className={classes.incomingTrpls}>Widget:</span>
                          <a className={classes.widgetLink} href={`/${data.nodeId}?tab=wid`}>
                            {data.widget === undefined || data.widget === null ? 0 : 1}
                          </a>
                        </div>

                        <div>
                          <div className={`${classes.flex} ${data.views.length ? classes.mb10 : ''}`}>
                            <span className={`${classes.incomingTrpls} ${classes.flex}`}>Views:</span>

                            {!data.views.length ? <span>None</span> : null}
                          </div>

                          {data.views.length ? (
                            <table className={`${classes.viewsTable}`}>
                              <thead>
                                <tr className={classes.row}>
                                  <td className={classes.pr20}>
                                    <i>id</i>
                                  </td>
                                  <td className={classes.pr20}>
                                    <i>name</i>
                                  </td>
                                  <td>
                                    <i>type</i>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {data.views.map((view, viewIndex) => {
                                  return (
                                    <tr className={classes.row} key={viewIndex}>
                                      <td className={classes.pr20}>{view.id}</td>
                                      <td className={classes.pr20}>{view.title}</td>
                                      <td>{view.type}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={classes.col50}>
                    <div
                      className={`${classes.group} ${classes.paper} ${classes.mb10} ${
                        !node.is_concept ? classes.op5 : ''
                      } ${classes.hoverOp1}`}
                    >
                      <div className={classes.groupTitle}>Restrictions</div>

                      <div className={classes.restrictionsContent}>
                        {node.is_concept && !data.restrictions_number
                          ? '0'
                          : data.restrictions_number
                          ? data.restrictions_number
                          : ''}
                      </div>

                      <a href={`/rst_edit?id=${node.id}`}>
                        <Edit className={`node-page-edit-btn ${classes.groupAddBtnIcon} ${classes.pointer}`} />
                      </a>
                    </div>

                    <div
                      className={`${classes.group} ${classes.paper} ${!node.is_concept ? classes.op5 : ''} ${
                        classes.hoverOp1
                      }`}
                    >
                      <div className={classes.groupTitle}>Categories</div>

                      {data.ako_subs.length ? (
                        <div className={`${classes.conceptsNodes} ${classes.column}`}>
                          {data.ako_subs.map((concept, conceptIndex) => {
                            return (
                              <Node
                                isLink
                                size="md"
                                nodeId={concept}
                                key={conceptIndex}
                                node={nodes[concept]}
                                nodes={nodes}
                                className={`${conceptIndex !== data.ako_subs.length - 1 ? classes.mb10 : ''}`}
                              />
                            );
                          })}
                        </div>
                      ) : (
                        <div className={classes.h60} />
                      )}

                      <a href={`/create_node?cid=${node.id}&type=ako`}>
                        <Add className={`node-page-edit-btn ${classes.groupAddBtnIcon} ${classes.pointer}`} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({ jels: state.jels }), {})(withStyles(styles)(NodePage));
